import { Step, styled } from '@mui/material'
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector'
import theme from 'src/styles/theme'

import * as S from './styles'

interface IStepperTextProps {
  label?: any
  currentStepName?: any
  course?: any
}

const Stepper = (props: IStepperTextProps) => {
  const { currentStepName, course } = props

  let steps = [
    {
      title: 'Documentos obrigatórios',
      name: 'documents',
    },
    {
      title: 'Dados do(a) candidato(a)',
      name: 'candidateData',
    },
    {
      title: 'Endereço do(a) candidato(a)',
      name: 'address',
    },
    {
      title: 'Sobre a escola',
      name: 'search',
    },
    {
      title: 'Dados do(a) responsável',
      name: 'responsibles',
    },
    {
      title: 'Confirmação',
      name: 'confirmation',
    },
  ]

  if (course == 'business' || course == 'tech') {
    steps = [
      {
        title: 'Instruções',
        name: 'instructions',
      },
      {
        title: 'Documentos obrigatórios',
        name: 'documents',
      },
      {
        title: 'Dados do(a) candidato(a)',
        name: 'candidateData',
      },
      {
        title: 'Endereço do(a) candidato(a)',
        name: 'address',
      },
      {
        title: 'Sobre a escola',
        name: 'search',
      },
      {
        title: 'Dados do(a) responsável',
        name: 'responsibles',
      },
      {
        title: 'Confirmação',
        name: 'confirmation',
      },
    ]
  }

  const QontoConnector = styled(StepConnector)(() => ({
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: `${theme.colors.primary.main}`,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: `${theme.colors.primary.main}`,
      },
    },
  }))

  return (
    <S.ContentBox>
      <S.Container>
        <S.ContainerStepper
          activeStep={steps.findIndex((step) => step.name === currentStepName)}
          alternativeLabel
          connector={<QontoConnector />}
        >
          {steps.map((step: any, index: any) => (
            <Step key={index}>
              <S.LabelStep>{step.title}</S.LabelStep>
            </Step>
          ))}
        </S.ContainerStepper>
        <S.Text>{props.label}</S.Text>
      </S.Container>
    </S.ContentBox>
  )
}

export { Stepper }

export type { IStepperTextProps }
